"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
// See: https://usehooks-ts.com/react-hook/use-hover
const useEventListener_1 = __importDefault(require("./useEventListener"));
function useHover(elementRef) {
    const [value, setValue] = (0, react_1.useState)(false);
    const handleMouseEnter = () => setValue(true);
    const handleMouseLeave = () => setValue(false);
    (0, useEventListener_1.default)('mouseenter', handleMouseEnter, elementRef);
    (0, useEventListener_1.default)('mouseleave', handleMouseLeave, elementRef);
    return value;
}
exports.default = useHover;
